export const googleAnalytics = (item) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(item);
    return true;
}
